import React from 'react';
import commonUtil from '../../../utils/commonUtil';
import { getClientDeviceId } from '../../../utils/deviceClient';

export default class Header extends React.Component {
  async componentDidMount() {
    // DeviceID Fix Start
    const opcId = Buffer.from(await getClientDeviceId()).toString('base64');
    const subDomainName = commonUtil.createSubDomainName();
    commonUtil.createCookiewithSubDomain('opcId', opcId, '/', subDomainName);
    // DeviceID Fix End
  }
  render() {
    const header = this.props.header;
    const dismiss = this.props.dismiss;
    const headerData = this.props.headerData;
    const dismissButton = this.props.dismissButton;
    return (
      <div className={this.props.headerClass} style={this.props.headerStyle}>
        {dismissButton && dismissButton }
        {dismiss === 'true' ? <button type="button" className="close" onClick={this.props.handleHide}>&times;</button> : ''}
        {header ? <h4 className={'modal-title ' + this.props.headerTitleClass}>{header}</h4> : ''}
        {headerData}
      </div>
    );
  }
}
